import { Outlet, Navigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore.js';
import { useUIStore } from '../../stores/uiStore.js';
import { Moon, Sun } from 'lucide-react';

export function AuthLayout() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const { darkMode, toggleDarkMode } = useUIStore();

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-gradient-to-br from-primary-50 via-white to-primary-100 p-4 dark:from-gray-950 dark:via-gray-900 dark:to-gray-950">
      {/* Decorative blobs */}
      <div className="pointer-events-none absolute -left-32 -top-32 h-96 w-96 rounded-full bg-primary-200/40 blur-3xl dark:bg-primary-900/20" />
      <div className="pointer-events-none absolute -bottom-32 -right-32 h-96 w-96 rounded-full bg-primary-300/30 blur-3xl dark:bg-primary-800/15" />

      {/* Theme toggle */}
      <button
        onClick={toggleDarkMode}
        className="absolute right-5 top-5 rounded-xl p-2.5 text-gray-500 transition-colors hover:bg-white/60 dark:text-gray-400 dark:hover:bg-gray-800/60"
        title={darkMode ? 'Açık mod' : 'Koyu mod'}
      >
        {darkMode ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
      </button>

      <div className="relative z-10 w-full max-w-md">
        {/* Logo */}
        <div className="mb-8 text-center">
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-primary-600 shadow-lg shadow-primary-500/30 dark:shadow-primary-400/10">
            <span className="text-xl font-black tracking-tight text-white">E</span>
          </div>
          <h1 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
            Elmes Platform
          </h1>
          <p className="mt-1.5 text-sm text-gray-500 dark:text-gray-400">
            Modüler uygulama yönetim sistemi
          </p>
        </div>

        {/* Card */}
        <div className="rounded-2xl border border-gray-200/60 bg-white/80 p-8 shadow-xl shadow-gray-200/40 backdrop-blur-sm dark:border-gray-700/50 dark:bg-gray-800/70 dark:shadow-black/20">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
